import {
	get,
	post,
	postForm
} from '../axios-req.js'
post
get
postForm
export const loginApi = {
	// 登录
	questionnaireLogin: (data) => {
		return postForm('/questionnaireLogin', data);
	},
}
